import PropTypes from 'prop-types';
import cn from 'classnames';

import LdsIcon from '../LdsIcon/index.jsx';

export default function LdsValidationError({
  id,
  className,
  children,
  ...rest
}) {
  return (
    <span
      id={id}
      className={cn(
        'lds-form-validation-error',
        className
      )}
      {...rest}
    >
      <LdsIcon name="WarningCircleFill" inline decorative />
      &nbsp;
      {children}
    </span>
  );
}

LdsValidationError.propTypes = {
  id: PropTypes.string.isRequired,
};
